module.exports = __webpack_public_path__ + "static/media/search-blue.a1b663d2.svg";